
import Vue from 'vue'

export default Vue.extend({
    props: {
        data: Object as () => TransferItemData,
        sym: String
    },
    computed: {
        isIn(): boolean { return this.data.owner === this.data.to },
        opposite(): string { return this.isIn ? this.data.from : this.data.to }
    }
})
